import React, { useState, useEffect } from "react";
import SidebarLayout from "../../../common/sidebar/SidebarLayout";
import { Helmet } from "react-helmet";
import OPSPrimaryHeader from "../../../common/primaryHeader/OPSPrimaryHeader";
import { InfoCard } from "../../dashboard/DashboardHome";
import CardLayout from "../../../common/cardLayout/CardLayout";
import {
  downloadUtilizationCSV,
  fetchHealthCareGroupsSolo,
  getClinicCount,
  getPatientCount,
} from "../../../../store/features/ops/opsSlice";
import { CTooltip } from "@coreui/react";
import UserAddedDataTable from "./UserAddedDataTable";
import { ReactComponent as DownloadIcon } from "../../../../assets/icons/download.svg";
import PatientLoader from "../../../common/PatientLoader";
import Select from "react-select";
import "./Utilization.css";
import { dateOptions } from "../../../../constants/constants";
import ClinicsGraph from "./ClinicsGraph";
import InfoIcon from "../../../../assets/icons/info.svg";
import { notify } from "../../../../util/helpers";

const Utilization = () => {
  const [monthwiseDataLoading, setMonthwiseDataLoading] = useState(true);
  const [totalNoOfClinics, setTotalNoOfClinics] = useState(0);
  const [totalNoOfPatients, setTotalNoOfPatients] = useState(0);
  const [totalNoOfNewPatients, setTotalNoOfNewPatients] = useState(0);
  const [monthwiseData, setMonthwiseData] = useState({});
  const [graphData, setGraphData] = useState({});
  const [opsLoading, setOpsLoading] = useState(true);
  const [healthcareGroups, setHealthcareGroups] = useState([]);
  const [clinicGraphData, setClinicGraphData] = useState({});
  const [clinicDateRange, setClinicDateRange] = useState(dateOptions[2]);
  const [patientsDateRange, setPatientsDateRange] = useState(dateOptions[2]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: "none",
      boxShadow: state.isFocused ? "none" : "none",
      borderColor: state.isFocused ? "#46beed" : base.borderColor,
      "&:hover": {
        borderColor: state.isFocused ? "#46beed" : base.borderColor,
      },
    }),
  };

  useEffect(() => {
    getClinicCount(clinicDateRange?.value)
      .then((res) => {
        setClinicGraphData(res?.data?.data);
      })
      .catch((e) => {
        console.log(e);
      });
    fetchHealthCareGroupsSolo({ is_test_account: 0, search: "" })
      .then((res) => {
        if (res.status === 200) {
          setHealthcareGroups(res.data);
        }
        setOpsLoading(false);
      })
      .catch((e) => {
        setOpsLoading(false);
      });

    getPatientCount(patientsDateRange?.value)
      .then((res) => {
        setMonthwiseData(res?.data?.data);
        setGraphData(res?.data?.graph_data);
        setTotalNoOfNewPatients(res?.data?.current_month_patients);
        setTotalNoOfClinics(res?.data?.total_clinics_count);
        //current_year_count
        setTotalNoOfPatients(res?.data?.total_patients_count);
        setMonthwiseDataLoading(false);
      })
      .catch((e) => {
        setMonthwiseDataLoading(false);
      });
  }, []);

  const [isDownloading, setIsDownloading] = useState(false);
  const downloadCSVData = (months) => {
    if (isDownloading) {
      notify("File generation is in progress, please wait..", "info");
      return;
    }
    notify("Your file will be ready shortly..", "info");
    downloadUtilizationCSV(months)
      .then((res) => {
        if (res.status === 200) {
          window.open(res?.data?.url);
        }
        setIsDownloading(false);
      })
      .catch((e) => {
        console.log(e);
        notify("Something went wrong! Try again later!", "error");
        setIsDownloading(false);
      });
  };

  return (
    <SidebarLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Utilization Report | Rose Health</title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <div className="container-fluid">
        <div className="container-fluid px-3">
          <OPSPrimaryHeader
            titleText={`Utilization Report`}
            showSubtitle={false}
            showButton={false}
            showPill={false}
          />
        </div>
        <div className="row w-100" style={{ margin: "0px" }}>
          <div
            className="col-sm-12 col-md-4 col-lg-4"
            style={{
              border: "5px solid transparent",
              boxSizing: "border-box",
              backgroundClip: "padding-box",
            }}
          >
            <InfoCard
              title={"Total No. of Clinics"}
              stats={totalNoOfClinics || 0}
              information={"Total No. of Clinics"}
              show_link={false}
            />
          </div>
          <div
            className="col-sm-12 col-md-4 col-lg-4"
            style={{
              border: "5px solid transparent",
              boxSizing: "border-box",
              backgroundClip: "padding-box",
            }}
          >
            <InfoCard
              title={"Total No. of Patients"}
              stats={totalNoOfPatients || 0}
              information={"Total No. of Patients"}
              show_link={false}
            />
          </div>
          <div
            className="col-sm-12 col-md-4 col-lg-4"
            style={{
              border: "5px solid transparent",
              boxSizing: "border-box",
              backgroundClip: "padding-box",
            }}
          >
            <InfoCard
              title={"Total No. of New Patients This Month"}
              stats={totalNoOfNewPatients || 0}
              information={"Total No. of New Patients This Month"}
              show_link={false}
            />
          </div>
        </div>

        {/* GRAPHS SECTION */}
        <div className="container-fluid row my-3 mx-0">
          <CardLayout
            className="col-sm-12 col-md-6 col-lg-6"
            style={{
              border: "5px solid transparent",
              boxSizing: "border-box",
              backgroundClip: "padding-box",
            }}
          >
            <div className="d-flex justify-content-between w-100 pt-3">
              <h5 style={{ textAlign: "left" }}>No. Of Clinics Added</h5>

              <CTooltip content="Total number of clinics added">
                <img
                  style={{ cursor: "pointer" }}
                  src={InfoIcon}
                  height="15px"
                  width="15px"
                  alt="Information Icon"
                />
              </CTooltip>
            </div>
            {monthwiseDataLoading ? (
              <PatientLoader />
            ) : (
              <div className="container-fluid mb-4">
                <div className="d-flex w-100">
                  <Select
                    value={clinicDateRange}
                    onChange={(e) => {
                      setClinicDateRange(e);
                    }}
                    options={dateOptions}
                    styles={customStyles}
                  />
                </div>
                <ClinicsGraph
                  months={clinicDateRange?.value}
                  data={clinicGraphData}
                />
              </div>
            )}
          </CardLayout>
          <CardLayout
            className="col-sm-12 col-md-6 col-lg-6"
            style={{
              border: "5px solid transparent",
              boxSizing: "border-box",
              backgroundClip: "padding-box",
            }}
          >
            <div className="d-flex justify-content-between w-100 pt-3">
              <h5 style={{ textAlign: "left" }}>No. Of Patients Added</h5>

              <CTooltip content="Total number of patiients added">
                <img
                  style={{ cursor: "pointer" }}
                  src={InfoIcon}
                  height="15px"
                  width="15px"
                  alt="Information Icon"
                />
              </CTooltip>
            </div>
            {monthwiseDataLoading ? (
              <PatientLoader />
            ) : (
              <div className="container-fluid mb-4">
                <div className="d-flex w-100">
                  <Select
                    value={patientsDateRange}
                    onChange={(e) => {
                      setPatientsDateRange(e);
                    }}
                    options={dateOptions}
                    styles={customStyles}
                  />
                </div>
                <ClinicsGraph
                  months={patientsDateRange?.value}
                  data={graphData}
                />
                <br />
              </div>
            )}
          </CardLayout>
        </div>

        {/* TABLE SECTION */}
        <div className="container-fluid my-3">
          <CardLayout
            className="container-fluid w-100 my-3"
            style={{
              boxShadow: "0px 5px 10px rgba(80, 110, 131, 0.19)",
            }}
          >
            <div className="d-flex justify-content-between w-100 p-3">
              <h5 style={{ textAlign: "left" }}>
                Healthcare Group - Patients added per month
              </h5>
              <div className="d-flex" style={{ gap: "5px" }}>
                <button
                  onClick={() => {
                    downloadCSVData(patientsDateRange?.value || 12);
                  }}
                  disabled={isDownloading}
                  className="btn alternative-btn px-3"
                >
                  <DownloadIcon /> Download CSV
                </button>
                <Select
                  value={patientsDateRange}
                  onChange={setPatientsDateRange}
                  options={dateOptions}
                  styles={customStyles}
                />
              </div>
            </div>
            {opsLoading || monthwiseDataLoading ? (
              <PatientLoader text="" />
            ) : (
              <>
                <UserAddedDataTable
                  months={patientsDateRange?.value}
                  monthwiseData={monthwiseData}
                  healthcareGroups={healthcareGroups}
                  loading={opsLoading && monthwiseDataLoading}
                />
              </>
            )}
          </CardLayout>
        </div>
      </div>
    </SidebarLayout>
  );
};

export default Utilization;
